export const EMOTES = ['thumbs', 'laugh', 'wow', 'angry', 'think', 'clap', 'cry', 'fire', 'swords', 'crown'] as const;
export type EmoteId = (typeof EMOTES)[number];

export type ChatMessage =
  | { id: string; kind: 'text'; userId: string; username: string; text: string; at: number }
  | { id: string; kind: 'emote'; userId: string; username: string; emote: EmoteId; at: number }
  | { id: string; kind: 'system'; code: string; params?: Record<string, string | number>; at: number };

export const CHAT_MAX_LENGTH = 300;
export const CHAT_HISTORY = 100;
